import React from 'react';
import { useT } from '../../../../i18n';

const TASKS = [
  { label: 'Commander les faire-part', tag: 'Papeterie', color: '#f7e9e1' },
  { label: 'Envoyer les faire-part', tag: 'Papeterie', color: '#f7e9e1' },
  { label: 'Acheter les chaussures et accessoires', tag: 'Tenues', color: '#fceaec' },
];

// Rétroplanning : les tâches de la période se cochent une à une.
const RetroVisual: React.FC = () => {
  const t = useT();
  return (
    <div className="mk-fv-box mk-fv-retro">
      <div className="mk-fv-retro-head">
        <b>{t('{a}-{b} mois avant', { a: 4, b: 6 })}</b>
        <span className="mk-fv-pill is-now">{t('En ce moment')}</span>
      </div>
      <span className="mk-fv-progress">
        <i />
      </span>
      <div className="mk-fv-task is-done">
        <span className="mk-fv-check">
          <i>✓</i>
        </span>
        <span className="mk-fv-task-label">{t('Réserver le photographe')}</span>
        <span className="mk-fv-tag" style={{ background: '#f3e8f7' }}>
          {t('Photo')}
        </span>
      </div>
      {TASKS.map((task, i) => (
        <div key={task.label} className="mk-fv-task">
          <span className="mk-fv-check">
            <i className={`mk-fv-tick${i}`}>✓</i>
          </span>
          <span className={`mk-fv-task-label mk-fv-strike${i}`}>{t(task.label)}</span>
          <span className="mk-fv-tag" style={{ background: task.color }}>
            {t(task.tag)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default RetroVisual;
